import { default as RealZoomVideo } from '@zoom/videosdk'

import { MockZoomVideo } from './tests/MockZoomVideo'

export default window.Cypress ? MockZoomVideo : RealZoomVideo
// oxlint-disable-next-line import/export -- @zoom/videosdk declares its named exports in dist/types only, so the resolver cannot see them.
export * from '@zoom/videosdk'
